// extracted by mini-css-extract-plugin
export var text_wrapper = "whyUsMultiple-module--text_wrapper--Fxw1j";
export var text_inner_wrapper = "whyUsMultiple-module--text_inner_wrapper--UY1c4";
export var subtitle = "whyUsMultiple-module--subtitle--FEFl3";
export var star_wrapper = "whyUsMultiple-module--star_wrapper--TjkNS";
export var vector_wrapper = "whyUsMultiple-module--vector_wrapper--dvzCn";
export var dark_section = "whyUsMultiple-module--dark_section--QvURK";
export var light_section = "whyUsMultiple-module--light_section--ZCvgG";